(ns app.front.view.public-notice.confirm-email
  (:require [app.front.state-machine :as sm]
            [app.front.util :as futil]
            [app.front.validate :as validate :refer [field-invalid?]]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [re-frame.core-instrumented :as rf]))


(def error-messages {:user/email      [[validate/Email :validate/wrong-email-address]]
                     :user/first-name [[validate/NonBlankString :validate/blank-first-name]]
                     :user/last-name  [[validate/NonBlankString :validate/blank-last-name]]
                     :terms-checked?  [[validate/True :validate/terms-not-checked]]})


(defn initial-model [email first-name last-name terms? workspace-id]
  {:user/email      email
   :user/first-name first-name
   :user/last-name  last-name
   :workspace-id    workspace-id
   :terms-checked?  terms?
   ::state          nil
   ::show-errors?   false
   ::errors         {}})


(def state-machine
  {nil                 {::init ::ready}
   ::ready             {::change-model ::client-validation
                        ::try-submit   ::submitting}
   ::client-validation {::no-errors    ::ready
                        ::still-errors ::client-validation}
   ::submitting        {::submit-success ::done}
   ::email-exists      {::change-model ::client-validation}})


;; -- Subscriptions -----------------------------------------------------------


(rf/reg-sub ::model
  (fn [db _] (get db ::registration-confirm-email)))


(rf/reg-sub ::state
  :<- [::model]
  (fn [model _] (get model ::state)))


(rf/reg-sub ::user-email
  :<- [::model]
  (fn [model _] (get model :user/email)))


(rf/reg-sub ::show-errors?
  :<- [::model]
  (fn [model _] (get model ::show-errors?)))


(rf/reg-sub ::submit-disabled?
  :<- [::state]
  :<- [::valid? :user/email]
  :<- [::valid? :user/first-name]
  :<- [::valid? :user/last-name]
  :<- [::valid? :terms-checked?]
  (fn [[state valid-email? valid-first? valid-last? valid-terms?] _]
    (or (= state ::submitting)
        (and (#{::ready ::client-validation} state)
             (not (and valid-email? valid-first? valid-last? valid-terms?))))))


(rf/reg-sub ::terms-checked?
  :<- [::model]
  (fn [model _] (get model :terms-checked?)))


(rf/reg-sub ::valid?
  :<- [::model]
  (fn [model [_ attr]]
    (let [validator #(validate/validate-field % model error-messages)]
      (not (field-invalid? validator attr)))))


;; -- Events ------------------------------------------------------------------


(def update-next-state (sm/make-update-next-state state-machine
                                                  [::registration-confirm-email ::state]))


(defn handle-change-model
  [{:keys [db]} [event field value]]
  {:db       (-> db
                 (assoc-in [::registration-confirm-email field] value)
                 (update-next-state event))
   :dispatch [::validate-fields]})


(defn handle-submit-clicked
  [{:keys [db]} _]
  {:db       (assoc-in db [::registration-confirm-email ::show-errors?] true)
   :dispatch (if-not (empty? (validate/validate-form (::registration-confirm-email db) error-messages))
               [::validate-fields]
               [::try-submit])})


(defn handle-validate-fields
  [{:keys [db]} _]
  {:dispatch (if (empty? (validate/validate-form (::registration-confirm-email db) error-messages))
               [::no-errors]
               [::still-errors])})


(defn handle-try-submit
  [{:keys [db]} [event _]]
  (let [lang (:language db)]
    {:db           (update-next-state db event)
     :comm/command {:command        :public-notice/send-confirmation
                    :data           (merge (select-keys (::registration-confirm-email db) [:user/email
                                                                                           :user/first-name
                                                                                           :user/last-name
                                                                                           :workspace-id])
                                           {:language lang})
                    :on-success     [::submit-success]
                    :on-bad-request [::submit-failure]}}))


(defn handle-submit-failure [_ [_ status body]]
  (js/console.error "::submit-failure" status body)
  {:dispatch [::submit-email-exists]})


(rf/reg-event-fx ::init
  (fn [{:keys [db]} [event workspace-id]]
    (let [{{:user/keys [email first-name last-name terms-checked?]} ::registration-confirm-email} db]
      {:db (-> db
               (assoc ::registration-confirm-email
                      (initial-model
                        (if (str/blank? email)
                          (-> db :session/user :user/email)
                          email)
                        (if (str/blank? first-name)
                          (-> db :session/user :user/first-name)
                          first-name)
                        (if (str/blank? last-name)
                          (-> db :session/user :user/last-name)
                          last-name)
                        (if (some? terms-checked?)
                          terms-checked?
                          false)
                        workspace-id))
               (update-next-state event))})))


(rf/reg-event-fx ::change-model handle-change-model)
(rf/reg-event-fx ::validate-fields handle-validate-fields)
(rf/reg-event-fx ::submit-clicked handle-submit-clicked)

(rf/reg-event-db ::no-errors update-next-state)
(rf/reg-event-db ::still-errors update-next-state)

(rf/reg-event-fx ::try-submit handle-try-submit)
(rf/reg-event-db ::submit-email-exists update-next-state)
(rf/reg-event-db ::submit-success update-next-state)
(rf/reg-event-fx ::submit-failure handle-submit-failure)


;; -- View ------------------------------------------------------------------


(defn public-notice-email-form [tr workspace-id]
  (let [show-errors?                              (<sub [::show-errors?])
        submit-disabled?                          (<sub [::submit-disabled?])
        {:user/keys [email first-name last-name]} (<sub [::model])
        email-valid?                              (<sub [::valid? :user/email])
        terms-valid?                              (<sub [::valid? :terms-checked?])
        invalid-email?                            (and (not email-valid?)
                                                       (not submit-disabled?))
        logged-in?                                (<sub [:session/logged-in?])]
    [:form.flex.flex-col.items-stretch.self-stretch
     {:on-submit (fn [e] (.preventDefault e) (>evt [::submit-clicked]))}
     [:div.flex.mb-5.required-input
      (cc/text-input {:id            (str "public-notice-email-register" workspace-id)
                      :label-text    (tr [:email-address])
                      :required      true
                      :light         true
                      :type          :email
                      :auto-focus    false
                      :class-name    "bg-white py-5 bg-ui-white"
                      :placeholder   (tr [:public-notice/email-placeholder])
                      :invalid       invalid-email?
                      :invalid-text  (if invalid-email?
                                       (tr [:validate/wrong-email-address])
                                       "")
                      :default-value email
                      :disabled      logged-in?
                      :on-change     (fn [e] (rf/dispatch-sync [::change-model :user/email (str/lower-case (futil/tval e))]))})]
     [:div.flex.mb-5.required-input
      (cc/text-input {:id            (str "public-notice-firstname-register" workspace-id)
                      :label-text    (tr [:user/first-name])
                      :required      true
                      :light         true
                      :auto-focus    false
                      :class-name    "bg-white py-5 bg-ui-white"
                      :default-value first-name
                      :disabled      logged-in?
                      :on-change     (fn [e] (rf/dispatch-sync [::change-model :user/first-name (futil/tval e)]))})]
     [:div.flex.mb-5.required-input
      (cc/text-input {:id            (str "public-notice-lastname-register" workspace-id)
                      :label-text    (tr [:user/last-name])
                      :required      true
                      :light         true
                      :auto-focus    false
                      :class-name    "bg-white py-5 bg-ui-white"
                      :default-value last-name
                      :disabled      logged-in?
                      :on-change     (fn [e] (rf/dispatch-sync [::change-model :user/last-name (futil/tval e)]))})]
     [:div.flex
      [:label.flex.flex-row.items-center.justify-center.self-center
       (cc/checkbox {:id         (str "public-notice-term-agree-check" workspace-id)
                     :label-text ""
                     :checked    (<sub [::terms-checked?])
                     :on-change  #(>evt [::change-model :terms-checked? %])})]
      [:span.pr-5.pl-2.my-auto (tr [:register/agree-terms])
       [:a {:href       (href/href :view/public-notice {:workspace-id workspace-id} {:terms true})
            :class-name "ml-1 no-underline hover:underline text-ui-blue"}
        (tr [:register/terms-of-service])]]
      (when (and show-errors?
                 (not terms-valid?))
        [:div.bx--form-requirement.mb-4.text-center (tr [:validate/terms-not-checked])])]
     [:div.flex.px-5.pt-5.pb-0.justify-center
      (cc/button
        {:type       :submit
         :disabled   submit-disabled?
         :class-name "px-8 bg-ui-night-sky-100 hover:bg-ui-night-sky-90 rounded-md text-lg font-bold"}
        (tr [:public-notice/subscribe-title]))]]))


(defn submit-success [tr email]
  (let [logged-in? (<sub [:session/logged-in?])]
    [:div.flex.flex-col
     [:h3.p-5.m-0 (tr (if logged-in?
                        [:public-notice/subscribed-title]
                        [:public-notice/subscription-confirmation-sent]))]
     [:div.flex.items-start.pb-5.px-5.leading-snug
      (tr (if logged-in?
            [:public-notice/subscribed]
            [:public-notice/subscription-confirmation-text]) [email])]]))


(defn view [workspace-id _]
  (let [tr (<sub [:tr])]
    [:div.flex.flex-col.items-start.justify-center
     (case (<sub [::state])
       ::done [submit-success tr (<sub [::user-email])]
       [public-notice-email-form tr workspace-id])]))
